export const GET_SCOPED_QUERYSTRING = 'GET_SCOPED_QUERYSTRING';
